<template>
    <div style="display: inline-block;">
        <RadioButton id="tw-radio" :disabled="readonly" v-model="text" :value="value" style="vertical-align: middle;" @click="click" @change="change" />
        <label for="tw-radio" style="padding: 0 5px;">
            <slot>单选框</slot>
        </label>
    </div>
</template>

<script>
import { computed } from 'vue'
import RadioButton from 'primevue/radiobutton';

export default {
    name: 'tw-radio',
    components: {
        RadioButton
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? [] : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        const click = () => {
            context.emit('click')
        }

        const change = () => {
            context.emit('change')
        }

        return {
            text,
            click,
            change
        }
    },
    props: {
        modelValue: null,
        value: String,
        readonly: Boolean
    }
}
</script>
